// Utilities for the canonical "providerId:modelName" format used across M2+.
// Mirrors ChatModelId helpers in ProviderContracts.cs.

export function parseChatModelId(id: string): { providerId: string; modelName: string } | null {
  const idx = id.indexOf(':');
  if (idx <= 0 || idx === id.length - 1) return null;
  return { providerId: id.slice(0, idx), modelName: id.slice(idx + 1) };
}

export function buildChatModelId(providerId: string, modelName: string): string {
  return `${providerId}:${modelName}`;
}

const PROVIDER_LABEL: Record<string, string> = {
  'openai': 'OpenAI',
  'anthropic': 'Anthropic',
  'azure-ai-foundry': 'Azure AI Foundry',
  'azure-openai': 'Azure OpenAI',
};

export function providerLabel(providerId: string): string {
  return PROVIDER_LABEL[providerId] ?? providerId;
}

export function providerBadgeColor(
  providerId: string,
): 'brand' | 'informative' | 'success' | 'important' | 'severe' {
  switch (providerId) {
    case 'azure-openai':     return 'brand';
    case 'openai':           return 'success';
    case 'anthropic':        return 'important';
    case 'azure-ai-foundry': return 'severe';
    default:                 return 'informative';
  }
}

export const RETIRED_PROVIDER_IDS = new Set<string>(['azure-openai']);
